/* unplugin-vue-components disabled */import script from "./message-custom.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-custom.vue?vue&type=script&lang=ts&setup=true"

import "./message-custom.vue?vue&type=style&index=0&id=05301dfe&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05301dfe"]])

export default __exports__